// Conference URL platform detection — TASK-425.
//
// The regexes here MUST stay in sync with the backend equivalents in
// `backend/meeting_orchestrator/services/attendee_dispatcher.py`
// (`_TEAMS_PATTERNS`, `_MEET_PATTERNS`). Broadening one side without the
// other lets the frontend offer "Auto-join" for a URL the bot will then
// refuse to dispatch on.

export type ConferencePlatform = 'teams' | 'meet'

const TEAMS_PATTERNS = [
  'teams.microsoft.com/l/meetup-join',
  'teams.live.com/meet/',
]
const MEET_PATTERNS = ['meet.google.com/']

export function detectPlatform(url: string | null | undefined): ConferencePlatform | null {
  if (!url) return null
  if (TEAMS_PATTERNS.some((p) => url.includes(p))) return 'teams'
  if (MEET_PATTERNS.some((p) => url.includes(p))) return 'meet'
  return null
}

export function shouldOfferBot(url: string | null | undefined): boolean {
  return detectPlatform(url) !== null
}
